/**
 * Cart Gift Box Opt-out
 * Saves the "I don't need a gift box" checkbox to the cart attribute "Gift box".
 * The checkbox is checked by default; the default is written to the cart the first
 * time it renders so every order records a choice.
 */
import { ThemeEvents } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

const ATTRIBUTE_NAME = 'Gift box';

async function saveGiftBoxChoice(checkbox) {
  const wrapper = checkbox.closest('.cart-gift-box-optout');
  const value = checkbox.checked ? 'Not needed' : 'Requested';

  checkbox.disabled = true;

  try {
    const response = await fetch(
      window.Theme?.routes?.cart_update_url ?? '/cart/update.js',
      fetchConfig('json', { body: JSON.stringify({ attributes: { [ATTRIBUTE_NAME]: value } }) })
    );
    if (!response.ok) throw new Error(`Failed to save gift box choice (${response.status})`);
    if (wrapper) delete wrapper.dataset.needsSync;
  } catch (err) {
    console.error('Gift box opt-out error:', err);
    checkbox.checked = !checkbox.checked;
  } finally {
    checkbox.disabled = false;
  }
}

function syncDefault() {
  const checkbox = document.querySelector('.cart-gift-box-optout[data-needs-sync="true"] .cart-gift-box-optout__checkbox');
  if (checkbox && !checkbox.disabled) saveGiftBoxChoice(checkbox);
}

document.addEventListener('change', (event) => {
  const checkbox = event.target;
  if (!checkbox.classList?.contains('cart-gift-box-optout__checkbox')) return;
  saveGiftBoxChoice(checkbox);
});

document.addEventListener(ThemeEvents.cartUpdate, () => requestAnimationFrame(syncDefault));
syncDefault();
